import { render, staticRenderFns } from "./NotesManager.vue?vue&type=template&id=9d4dd20a"
import script from "./NotesManager.vue?vue&type=script&lang=js"
export * from "./NotesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports